<template>
  <div class="about" style="background-color: aqua; display: flex; " >
    <!-- <div id="about"  style="width: 500px; height: 800px;"></div> -->
    <!-- <h1>This is an about page</h1> -->
    <!-- <MindElixirDialog :visible.sync="show" /> -->

    <p v-html="content"></p>
    <!-- <iframe src="https://emoawps.pumc.edu.cn/weboffice/office/w/1843558171183095810?_w_appid=KWIZITBBNCZUKHHU&_w_third_appid=KWIZITBBNCZUKHHU&_w_third_file_id=1843558171183095810&route_key=&wpsPreview=1110110&simple&hidecmb&readonly"></iframe> -->
  </div>
</template>


<script>
// import MindElixirDialog from '../components/MindElixirDialog.vue';
export default {

  components:{

  },
  data(){
    return {
      show:true,
      content:'<p style=\"text-indent: 2em;\"><span style=\"font-family: 黑体, SimHei; font-size: 18px;\">杜玉林</span><span style=\"font-family: 宋体, SimSun;\">，男，副教授职称。现任职于石家庄铁路职业技术学院，国家级课程思政教学团队成员。主讲道路工程施工、桥梁工程施工、施工组织设计等课程，担任主编、副主编出版教材3部，公开发表论文多篇。</span></p><p style=\"text-indent: 2em;\"><span style=\"font-family: 黑体, SimHei; font-size: 18px;\">杜立峰</span><span style=\"font-family: 宋体, SimSun;\">，男，教授职称，现任职于石家庄铁路职业技术学院，河北省“三三三人才工程”人选，国家级课程思政教学团队成员。</span></p><p><br/></p>>'
    }
  },

  mounted(){
    // this.$store.state.showNaotu = true
  }

}
</script>